import { createSlice } from '@reduxjs/toolkit';

export const initialState = {
	products: {
		data: {
			total: 0,
			results: []
		},
		isLoading: false,
		hasBeenLoaded: false,
		error: ''
	}
};

export const productsSlice = createSlice({
	name: 'products',
	initialState,
	reducers: {
		getProducts: (state) => {
			state.products.isLoading = true;
		},
		getProductsCompleted: (state, action) => {
			state.products.isLoading = false;
			state.products.data = action.payload;
			state.products.hasBeenLoaded = true;
			state.products.error = '';
		},
		getProductsFailed: (state, action) => {
			state.products.isLoading = false;
			state.products.hasBeenLoaded = false;
			state.products.error = action.payload;
		}
	}
});

export const { getProducts, getProductsCompleted, getProductsFailed } =
	productsSlice.actions;

export default productsSlice.reducer;
